import { useKinderConnectCaptureContext } from './kinder-connect-capture-context';
/**
 * Returns a submit handler for the KinderConnect capture form.
 * Reads the onCapture callback from context, calls it with the captured values,
 * waits for what it returns, then calls onClose to dismiss the modal.
 *
 * @param _options - Unused options object (provided by the generated modal form).
 * @param onClose - Called after onCapture to close the modal.
 * @returns A function that accepts the completed form values and fires the capture callback.
 */
export const useKinderConnectCaptureSubmit = (_options, onClose) => {
    const { onCapture } = useKinderConnectCaptureContext();
    return async (formValues) => {
        await onCapture(formValues);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
};
